import { Student, BusStudentCheckin, BusCheckin } from '@/plugins/api'
import moment from 'moment'

export default {
  namespaced: true,
  state: {
    student: {},
    studentCheckins: [],
    loading: false,
    attendanceStudentSearchParams: {},
    date: moment()
      .startOf('day')
      .toISOString()
  },
  actions: {
    async fetchData({ commit, state }, attendanceParam) {
      const student = await Student.fetchOne(attendanceParam.student)

      const studentCheckins = await BusStudentCheckin.getBusAttendanceStudents(attendanceParam)

      commit('changeState', {
        student,
        studentCheckins,
        attendanceStudentSearchParams: attendanceParam
      })
    },
    async createAttendance({ commit }, data) {
      try {
        const att = await BusStudentCheckin.create(data)
        commit('setAttendance', att)
        return att
      } catch (e) {
        alert.error(e)
      }
    },
    async updateBusCheckinStatus({ commit }, params) {
      try {
        await BusCheckin.updateBusCheckinStatus(params)
      } catch (e) {
        console.error(e)
        alert.error(e)
      }
    },
    async updateAttendance({ commit }, { id, ...attendance }) {
      commit('updateAttendance', await BusStudentCheckin.update(id, attendance))
    },

    setDate({ commit }, date) {
      commit('changeState', {
        date
      })
    }
  },
  mutations: {
    //
  }
}
